import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class APDSubsidy  {
    _originalTypeClassName = "zERP.BO.APDSubsidy";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
APDSubsidy.translate = translateService;
}
this.Id = null;
this.RecordType = null;
this.SubsidyTypeCode = null;
this.InsuredPercentage = null;
this.InsuredAmount = null;
this.EmployerPercentage = null;
this.EmployerAmount = null;
this.TotalSubsidyAmount = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
RecordType:any;
SubsidyTypeCode:any;
InsuredPercentage:any;
InsuredAmount:any;
EmployerPercentage:any;
EmployerAmount:any;
TotalSubsidyAmount:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}